<template>
  <div>
    <vue-headful
      title="Profile Preferences | Gradely.ng - School"
      description="Description goes here"
    />

    <div class="settings-display-layout white rounded-10">
      <!-- PAGE TITLE -->
      <div class="page-title">Profile Preferences</div>

      <!-- PERSONAL PROFILE CARD COMPONENT -->
      <PersonalProfileCard
        :fullname="getAuthUser.full_name"
        :avatar_img="getAuthUser.image"
      ></PersonalProfileCard>
      <!-- PERSONAL PROFILE CARD COMPONENT -->

      <!-- FORM DIVIDEER -->
      <div class="form-divider"></div>
      <!-- PERSONAL PROFILE DETAILS COMPONENT -->
      <PersonalProfileDetails
        :fullname="getAuthUser.full_name"
        :email="getAuthUser.email"
      ></PersonalProfileDetails>

      <!-- FORM DIVIDER -->
      <div class="form-divider"></div>
      <!-- NOTIFICATION COLUMN COMPONENT -->
      <NotificationColumn
        notification_msg="Choose the type of notifications you want to receive from Gradely"
        notification_route="/school/settings/notification"
      ></NotificationColumn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PersonalProfileCard from "@/components/globalComps/SettingsComps/ProfileComps/PersonalProfileCard";

export default {
  name: "SchoolSettingsUser",

  components: {
    PersonalProfileCard,
    PersonalProfileDetails: () =>
      import(
        /* webpackChunkName: "PersonalProfileDetails" */ "@/components/globalComps/SettingsComps/ProfileComps/PersonalProfileDetails"
      ),
    NotificationColumn: () =>
      import(
        /* webpackChunkName: "NotificationColumn" */ "@/components/globalComps/SettingsComps/ProfileComps/NotificationColumn"
      ),
  },

  computed: {
    ...mapGetters(["getAuthUser"]),
  },
};
</script>

<style lang="scss">
.settings-display-layout {
  .page-title {
    @include breakpoint_max(sm) {
      font-size: 13px !important;
      font-weight: 600 !important;
    }
  }
}
</style>
